import { combineReducers } from "redux";
import controls from "../modules/agora-live/components/streamControls/controls.reducer";
import application from "../application/application.reducer";
import login from "../modules/auth/Login/login.reducer";
import livemain from "../modules/live-main/livemain.reducer";
import interactionmain from "../modules/interactions/interactions.reducer";
import interaction from "../modules/interactions/components/interactionMedia/interactionMedia.reducer";
import record from "../modules/record-video/record-video.reducer";

export default combineReducers({
  // reducers
  controls,
  application,
  login,
  livemain,
  interactionmain,
  interaction,
  record
 
});
